import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import Dropzone from "react-dropzone-uploader";
import config from '../../../app/config';

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

import {ToastContainer, toast} from "react-toastify";


import DataTable from "react-data-table-component";
import {speaker} from "../../../api/speaker";
import {gruppi_relatori} from '../../../api/speaker_groups'
import relatoriUtil from './relatoriutils';
import {downloadFile} from "../../../utils/download.utils";


const Relatori = (props) => {
const columns = [
  {
    name: "Nome",
    selector: "name",
    sortable: true,
    center: true,
    className: "default-text mb-0 f-w-700 f-18",
    style: 'color: var(--primary-color);font-weight: 700;font-size: 14px;',
    width: '15%'

  },
  {
    name: "Cognome",
    selector: "surname",
    sortable: true,
    center: true,
    className: "default-text mb-0 f-w-700 f-18",
    style: 'color: var(--primary-color);font-weight: 700;font-size: 14px;',
    width: '15%'
  },
  {
    name: "Azioni",
    selector: "id",
    sortable: true,
    center: true,
    format: (row) => {
      return (
        <>
                <Button color="warning"
                    className="btn btn-pill btn-sm btn-air-warning btn-warning"
                    onClick={loadFormEdit.bind(this, row)}>Gestisci</Button>
          &nbsp;
          <Button color="primary"
                  className="btn btn-pill btn-sm btn-air-danger  btn-danger"
                  onClick={deletegroup.bind(this, row.id)}>Elimina</Button>
        </>
      )
    },
  },
];

  const [id, setId] = useState();
  const [last10relatori, setLast10Relatori] = useState([]);
  const [tabellarelatori, setTabellaRelatori] = useState([]);
  const [tabellarelatoriFiltro, setTabellaRelatoriFiltro] = useState([]);
  const [groupid, setGroupId] = useState('');
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [description, setDescription] = useState('');
  const [listagruppi, setListaGruppi] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [file, setFile] = useState({});
  const [linkImage, setLinkImage] = useState('');
  const [nome, setNome] = useState('');

  const getUploadParams = ({file}) => {
    const formData = new FormData();
    formData.append('file', file);
    return {
      // use this to skip origin
      //url: `/api/recorder/v1/upload`,
      url: `${config.serverUrl}/api/recorder/v1/upload`,
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('session_token')}`
      },
      body: formData
    };
  };

  const handleImageChangeStatus = ({meta, file, xhr}, status) => {
    console.log('handleImageChangeStatus');
    setIsLoading(true)

    if (status === 'done') {
      console.log(xhr.response);
      let response = JSON.parse(xhr.response);
      setFile(file => ({...file, imageUrl: response.key}))
      setIsLoading(false)
      console.log(response);
    }
  };


  useEffect(async () => {
    await load();
  }, []);

  const load = async () => {
    try {
      const listarelatori = await speaker.methods.loadRelatori();
      console.log('listaRelatori: ', listarelatori);
      //listarelatori.length = (listarelatori.length > 10 ? 10 : listarelatori.length);
      setLast10Relatori(listarelatori);
      setTabellaRelatori(listarelatori);
      setTabellaRelatoriFiltro(listarelatori);
    } catch (e) {
      toast.error('Impossibile recuperare i relatori')
      setLast10Relatori([]);
      setTabellaRelatori([]);
      setTabellaRelatoriFiltro([]);
    }

    try {
      const list = await gruppi_relatori.methods.loadGruppiRelatori();
      setListaGruppi(list);
    } catch (e) {
      toast.error('Impossibile recuperare i gruppi')
    }  

  }

  const deletegroup = async (id) => {
    try{
      if(await speaker.methods.deleteGruppo(id)){
        setTimeout(() => {
          toast.success(
            'Gruppo cancellato'
          );
        }, 300);
        load();
      }else{
        toast.error(
          'Il gruppo ha sessioni o utenti associati'
        );
      }
      
    }catch(e){
      toast.error(
        'Il gruppo ha sessioni o utenti associati'
      );
      console.log(e);
    }
    
  }


  const clearForm = () => {
    setId();
    setName('');
    setSurname('');
    setDescription('');
    setFile(null);
    setGroupId('');
    setLinkImage('');
    document.getElementById('groupselect').value='';
  }

  const loadFormEdit = (row) => {
    setId(row.id);
    setName(row.name)
    setSurname(row.surname)
    setDescription(row.description)
    setLinkImage(row.imageUrl)
    console.log(row);
    setGroupId(row.speakerGroups[0].id)
    document.getElementById('groupselect').value=row.speakerGroups[0].id;
  }

  const submit = async () => {

    setIsLoading(true)
    const inputobject = 
    {
      "speakerGroups": [
        {
          "id": groupid
        }
      ],
      "name": name,
      "surname": surname,
      "description": description,
    }
    if(id) inputobject.id=(id);
    const validateresult = relatoriUtil.methods.validateRelatore(inputobject);

    if (file?.imageUrl || linkImage)
      inputobject.imageUrl = (file?.imageUrl) ? file?.imageUrl : linkImage;

    if (validateresult.length) {
      //TODO gestire validate field su campo input
      validateresult.forEach((e) => {
          console.log(e);
          toast.error(
            e.field + ':' + e.error
          );
        }
      );
      setIsLoading(false)
      return;
    }
    try {
      if(id) {
         const result = await speaker.methods.updateRelatore(inputobject);
      } else {
         const result = await speaker.methods.saveRelatore(inputobject);
      }
     
      toast.success("Relatore salvato...");
      clearForm();
      await load();
    } catch (e) {
      toast.error("Qualcosa è andato storto...");
    } finally {
      setIsLoading(false)
    }
  }


  return (
    <Fragment>
      <Breadcrumb parent="Relatori" title="Gestione" subtitle="Relatori"/>
      <Container fluid={true}>
        <Row>
          <Col xs="12" sm="4" md="4" xl="4">
            <Card className="card-absolute">
              <CardHeader className="bg-primary">
                <h5>Upload</h5>
              </CardHeader>

              <CardBody className="add-post">
                <div className="media static-top-widget">
                  <div className="media-body">

                    <Row>
                      <Col xs="12" sm="12">
                        <Form id="savefiles" className="dropzone digits">
                          <div className="m-0 dz-message needsclick">

                            <Label>Immagine</Label>
                            <Dropzone
                              key='file_video'
                              getUploadParams={getUploadParams}
                              onChangeStatus={handleImageChangeStatus}
                              maxFiles={1}
                              multiple={false}
                              canCancel={false}
                              accept='.jpg, .png'
                              inputContent="Trascina il file qui o premi per sceglierlo"
                              styles={{
                                dropzone: {width: "100%", height: 50},
                                dropzoneActive: {borderColor: "green"},
                              }}
                            />
                          </div>
                          <div style={{width: '90%', margin: 'auto', textAlign: 'center'}}>
                            {
                              (linkImage && linkImage != '') ? (
                                <img className="img-fluid img-shadow-warning" src={linkImage} />
                              ) : ''                       
                            }
                            {
                              (linkImage && linkImage != '') ? (
                                <Button color="secondary btn-pill" type="reset" onClick={() => downloadFile(linkImage, nome)}>
                                  Scarica Immagine
                                </Button>) : ''                        
                            }

                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                </div>
              </CardBody>  
            </Card>
          </Col>    

          <Col xs="12" sm="8" md="8" xl="8">
            <Card className="card-absolute">
              <CardHeader className="bg-primary">
                <h5>Dati Relatore {name} {surname}</h5>
              </CardHeader>
              <CardBody className="add-post">
                <Form id="savesession" className="row needs-validation">
                  <Col sm="12">
                    <Row>
                      <Col xs="12" sm="6" md="6" xl="6" lg="6">
                        <FormGroup>
                          <Label for="validationCustom01">Nome:</Label>
                          <Input
                            className="form-control"
                            id="input_nome_relatore"
                            type="text"
                            placeholder=""
                            required={true}
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value)
                            }}
                          />
                          <div className="valid-feedback">Ok!</div>
                        </FormGroup>

                      </Col>
                      <Col xs="12" sm="6" md="6">

                      <FormGroup>
                          <Label for="validationCustom01">Cognome:</Label>
                          <Input
                            className="form-control"
                            id="input_cognome_relatore"
                            type="text"
                            placeholder=""
                            required={true}
                            value={surname}
                            onChange={(e) => {
                              setSurname(e.target.value)
                            }}
                          />
                          <div className="valid-feedback">Ok!</div>
                        </FormGroup>

                      </Col>

                      <Col xs="12" sm="12" md="12">

                      <FormGroup>
                          <Label for="validationCustom01">Descrizione:</Label>
                          <Input
                            className="form-control"
                            id="input_descrizione_relatore"
                            type="text"
                            placeholder=""
                            required={true}
                            value={description}
                            onChange={(e) => {
                              setDescription(e.target.value)
                            }}
                          />
                          <div className="valid-feedback">Ok!</div>
                        </FormGroup>

                      </Col>

                    </Row>
                    <Row>
                      <Col xs="12" sm="6" md="6" xl="6" lg="6">
                        <FormGroup>
                          <Label for="validationCustom01">Gruppo relatori:</Label>
                          <select id="groupselect" className="form-control btn-pill" onChange={(e) => {
                            setGroupId(e.target.value)
                          }} size="1">
                            <option value=''>Seleziona</option>
                            {
                              Array.isArray(listagruppi) ? listagruppi.map((data, i) => {
                                return (
                                  <option value={data.id}>{data.name}</option>
                                );
                              }) : <option value={1}>{'admin'}</option>
                            }


                          </select>


                        </FormGroup>

                      </Col>
                    </Row>

                  </Col>
                </Form>
                <Row>
                  &nbsp;
                </Row>
                <div className="btn-showcase" style={{textAlign: 'right'}}>
                  <Button disabled={isloading} id="buttonsubmit" color="primary btn-pill" type="button"
                          onClick={submit}>
                    Salva
                  </Button>
                  <Button color="danger btn-pill" type="reset" onClick={clearForm}>
                    Annulla
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>

        </Row>
        <Row>
          <Col xs="12" sm="12">
            <Card className="card-absolute">
              <CardHeader className="bg-secondary">
                <h5>Lista Relatori</h5>
              </CardHeader>
              <CardBody className="add-post">
                <div className="datatable-filter">
                  <div className="faq-form">
                    <Input
                      className="form-control "
                      type="text"
                      placeholder="Cerca relatore..."
                       
                      onChange={(e) => {
                        setTabellaRelatoriFiltro(tabellarelatori.filter(function (el) {
                            return el.name.toLowerCase().includes(e.target.value.toLowerCase()) || el.surname.toLowerCase().includes(e.target.value.toLowerCase());
                          })
                        );

                        console.log(e.target.value)
                      }}
                      onKeyPress={event => {
                        if (event.key === 'Enter') {
                          console.log(event.target.value);
                        }
                      }}
                    />
                  
                  </div>
                </div>  
                <DataTable
                  columns={columns}
                  data={tabellarelatoriFiltro}
                  striped={true}
                  center={true}
                  className="table-xs table table-styling"
                  style={{
                    marginTop: "0px",
                    maxWidth: "100%",
                    overflow: 'auto',
                    width: '100%',
                    position: 'relative',
                    top: '-55px'
                  }}
                  pagination={true}
                  paginationPerPage={10}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ToastContainer/>
      </Container>
    </Fragment>
  );
};


export default Relatori;
